var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"ttl"},[_c('div',[_c('span',{staticClass:"emp"},[_vm._v(_vm._s(_vm.titleLabel[_vm.type]))]),_vm._v(" (총 "),_c('span',{staticClass:"error"},[_vm._v(_vm._s(_vm.count))]),_vm._v("개 검색 결과) ")]),_c('div',{staticClass:"more pnt",on:{"click":_vm.viewMore}},[_vm._v(" 더보기"),_c('i',{staticClass:"i_ar_my_set_g"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }